var React = require('react');
import { Helmet } from "react-helmet";
import { Box, Container, Grid } from '@mui/material';
import AdminSidebar from "./AdminItems/AdminSidebar";





const AdminPanel = () => (
    <>
        <Helmet>
            <title>
                BeyondTime | Admin Panel
            </title>
        </Helmet>
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                py: 8
            }}
        >
        <AdminSidebar />
        </Box>    
    </>
);





export default AdminPanel;
